import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { CSSProperties, VFC } from "react";
import styled from "styled-components";
import { Markdown, SupTitle } from "components";
import { PipelineRoutingLinkButton } from "components/Molecules/PipelineRoutingLinkButton";
import { FullArrow } from "icons";
import { Hero2Content } from "types/graphql/generated";

interface Props {
  content: Hero2Content;
}

const Hero2: VFC<Props> = withErrorBoundary(
  ({ content: { title, description, buttonLabel, buttonLink, hero2SupTitle } }) => {
    const backgroundColor = hero2SupTitle ? "#FAF6F4" : "#fff";

    return (
      <StyledHero2
        style={
          {
            "--background-color": `${backgroundColor}`,
          } as CSSProperties
        }
      >
        <div className="Content">
          {hero2SupTitle && <SupTitle className="Hero2__supTitle Color_secondary">{hero2SupTitle}</SupTitle>}
          <h2 className="Hero2__title Font_64_72_600 sm:Font_48_54_600">{title}</h2>
          <Markdown className="Hero2__description Font_24_32_450 Color_secondary">{description}</Markdown>
          <PipelineRoutingLinkButton href={buttonLink} className="Hero2__button" rightIcon={<FullArrow />}>
            {buttonLabel}
          </PipelineRoutingLinkButton>
        </div>
      </StyledHero2>
    );
  },
  {}
);

const StyledHero2 = styled.section`
  background: var(--background-color);

  .Hero2__supTitle {
    color: ${({ theme }) => theme.colors.fog["60"]};
  }

  .Hero2__title {
    max-width: 733px;
    margin-top: 40px;
  }

  .Hero2__description {
    margin-top: 24px;
    max-width: 555px;
  }

  .Hero2__button {
    margin-top: 32px;
    width: fit-content;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    .Content {
      align-items: unset;
      text-align: unset;
    }

    .Hero2__button {
      margin-top: 40px;
    }
  }
`;

gql`
  fragment Hero2Content on ComponentHeroHero2 {
    hero2SupTitle
    title
    description
    buttonLabel
    buttonLink
  }
`;

export { Hero2 };
export type { Props as Hero2Props };
